import http from './http'

export default {
  merchant: {
    get (id) {
      return http.get('/merchant/get', { id: id })
    },
    getList (search, pageConfig) {
      return http.get('/merchant/getlist', {
        shopId: search.shopId,
        keyword: search.keyword,
        businessScope: search.businessScope,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    create (model) {
      return http.post('/merchant/create', model)
    },
    update (model) {
      return http.post('/merchant/update', model)
    },
    delete (id) {
      return http.post('/merchant/delete', id)
    },
    setPassword (model) {
      return http.post('/merchant/setpassword', model)
    },
    getProductOrigin (search) {
      return http.get('/merchant/getproductorigin', {
        merchantId: search.merchantId,
        productId: search.productId,
        date: search.date
      })
    }
  },
  merchantEvaluation: {
    get (id) {
      return http.get('/merchant/merchantevaluation/get', { id: id })
    },
    getList (search, pageConfig) {
      return http.get('/merchant/merchantevaluation/getlist', {
        shopId: search.shopId,
        startDate: search.startDate,
        endDate: search.endDate,
        keyword: search.keyword,
        level: search.level,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    }
  },
  merchantComplain: {
    get (id) {
      return http.get('/merchant/merchantcomplain/get', { id: id })
    },
    getList (search, pageConfig) {
      return http.get('/merchant/merchantcomplain/getlist', {
        startDate: search.startDate,
        endDate: search.endDate,
        shopId: search.shopId,
        keyword: search.keyword,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    update (model) {
      return http.post('/merchant/merchantcomplain/update', model)
    }
  },
  productTestRecord: {
    get (id) {
      return http.get('/merchant/producttestrecord/get', { id: id })
    },
    getList (search, pageConfig) {
      return http.get('/merchant/producttestrecord/getlist', {
        shopId: search.shopId,
        keyword: search.keyword,
        merchantId: search.merchantId,
        tested: search.tested,
        startDate: search.startDate,
        endDate: search.endDate,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    import (list) {
      return http.post('/merchant/producttestrecord/import', list)
    },
    create (model) {
      return http.post('/merchant/producttestrecord/create', model)
    },
    update (model) {
      return http.post('/merchant/producttestrecord/update', model)
    },
    delete (id) {
      return http.post('/merchant/producttestrecord/delete', id)
    }
  },
  productAccessAccount: {
    get (id) {
      return http.get('/merchant/productaccessaccount/get', { id: id })
    },
    getList (search, pageConfig) {
      return http.get('/merchant/productaccessaccount/getlist', {
        shopId: search.shopId,
        origin: search.origin,
        merchantId: search.merchantId,
        product: search.product,
        code: search.code,
        startDate: search.startDate,
        endDate: search.endDate,
        isAdjust: search.isAdjust,
        isPlus: search.isPlus,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    import (list) {
      return http.post('/merchant/productaccessaccount/import', list)
    },
    create (model) {
      return http.post('/merchant/productaccessaccount/create', model)
    },
    createList (model) {
      return http.post('/merchant/productaccessaccount/createlist', model)
    },
    update (model) {
      return http.post('/merchant/productaccessaccount/update', model)
    },
    delete (id) {
      return http.post('/merchant/productaccessaccount/delete', id)
    },
    queryAccountInfoInterface (model) {
      return http.post('/shop/queryandupload/queryaccountinfointerface', model)
    },
    saveQueryAccountInfoInterface (model) {
      return http.post('/shop/queryandupload/savequeryaccountinfointerface', model)
    }
  },
  merchantPraise: {
    get (id) {
      return http.get('/merchant/merchantpraise/get', { id: id })
    },
    getList (search, pageConfig) {
      return http.get('/merchant/merchantpraise/getlist', {
        shopId: search.shopId,
        startDate: search.startDate,
        endDate: search.endDate,
        keyword: search.keyword,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/merchant.js